import * as R from "ramda";

export const upCase = R.pipe(R.juxt([R.compose(R.toUpper, R.head), R.tail]), R.join(""));
